/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AuthenticationMethodType {
	Unknown = 'Unknown',
	Email = 'Email',
	Google = 'Google',
	Facebook = 'Facebook',
	Microsoft = 'Microsoft',
	Support = 'Support',
	Custom = 'Custom',
}
